import {
  GET_ADMIN_USER_NOTIFICATIONS,
  GET_ADMIN_USER_NOTIFICATIONS_SUCCESS,
  GET_ADMIN_USER_NOTIFICATIONS_ERROR,
  CREATE_USER_NOTIFICATIONS,
  CREATE_USER_NOTIFICATIONS_SUCCESS,
  CREATE_USER_NOTIFICATIONS_ERROR,
  UPDATE_USER_NOTIFICATIONS,
  UPDATE_USER_NOTIFICATIONS_SUCCESS,
  UPDATE_USER_NOTIFICATIONS_ERROR,
  DELETE_USER_NOTIFICATIONS,
  DELETE_USER_NOTIFICATIONS_SUCCESS,
  DELETE_USER_NOTIFICATIONS_ERROR,
} from "./actionTypes"
import { buildCampaignAnalysisCacheKey as buildPaginationCacheKey } from "helpers/sf_utils"

const initialState = {
  admin_user_notifications: [],
  error: null,
  last_end_date: null,
  last_start_date: null,
  loading: false,
  last_page_fetched: 0,
  total_number_of_pages: 0,
  active_cache_key: null,
  page_cache: {},
}

const NotificationsTerminal = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_USER_NOTIFICATIONS: {
      const page_number = action.paginated ? (action.payload.queryParams.page_number || 1) : 1
      const useCache = Boolean(action.payload?.useCache)
      const queryParams = action.payload?.queryParams || {}
      const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
      const shouldResetCache =
        useCache &&
        page_number === 1 &&
        state.active_cache_key &&
        state.active_cache_key !== cacheKey
      const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[page_number] : null

      return {
        ...state,
        loading: !cachedPage,
        active_cache_key: useCache ? cacheKey : null,
        admin_user_notifications: cachedPage?.rows || ((page_number === 1) ? [] : state.admin_user_notifications),
        last_page_fetched: cachedPage?.page_number ?? state.last_page_fetched,
        total_number_of_pages: cachedPage?.total_number_of_pages ?? state.total_number_of_pages,
        last_start_date: cachedPage?.start_date ?? state.last_start_date,
        last_end_date: cachedPage?.end_date ?? state.last_end_date,
        page_cache: shouldResetCache ? {} : state.page_cache,
      }
    }

    case GET_ADMIN_USER_NOTIFICATIONS_SUCCESS: {
      if (action.payload instanceof Array) {
        return {
          ...state,
          admin_user_notifications: action.payload,
          loading: false,
          error: null,
        }
      }

      const rows = action.payload.data || []
      const additional = action.payload.additional_data || {}
      const useCache = Boolean(action.meta?.useCache)
      const cacheKey = useCache ? buildPaginationCacheKey(action.meta?.queryParams || {}) : null
      const pageNum = parseInt(additional.page_number, 10)
      const totalPages = parseInt(additional.total_number_of_pages, 10)
      const safePage = Number.isFinite(pageNum) && pageNum > 0 ? pageNum : 1
      const safeTotal = Number.isFinite(totalPages) && totalPages >= 0 ? totalPages : 0
      const pageSnapshot = {
        rows,
        page_number: safePage,
        total_number_of_pages: safeTotal,
        start_date: additional.start_date,
        end_date: additional.end_date,
      }

      return {
        ...state,
        admin_user_notifications: rows,
        last_start_date: additional.start_date,
        last_end_date: additional.end_date,
        last_page_fetched: safePage,
        total_number_of_pages: safeTotal,
        loading: false,
        active_cache_key: useCache ? cacheKey : state.active_cache_key,
        page_cache: useCache ? {
          ...state.page_cache,
          [cacheKey]: {
            ...(state.page_cache?.[cacheKey] || {}),
            [safePage]: pageSnapshot,
          },
        } : state.page_cache,
      }
    }

    case GET_ADMIN_USER_NOTIFICATIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case CREATE_USER_NOTIFICATIONS:
      return {
        ...state,
        loading: true
      }

    case CREATE_USER_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        admin_user_notifications: [...state.admin_user_notifications, ...action.payload],
        loading: false,
        // New record may shift pagination; invalidate so all pages refetch fresh
        page_cache: {},
      }

    case CREATE_USER_NOTIFICATIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_USER_NOTIFICATIONS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_USER_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        admin_user_notifications: state.admin_user_notifications.map(
          aun => aun.id === action.payload.id ? ({ ...aun, ...action.payload }) : aun
        ),
        loading: false,
        // Patch current-page display immediately; invalidate cache so other pages refetch fresh
        page_cache: {},
      }

    case UPDATE_USER_NOTIFICATIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_USER_NOTIFICATIONS:
      return {
        ...state,
        loading: true
      }

    case DELETE_USER_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        admin_user_notifications: state.admin_user_notifications.filter(
          aun => aun.id != action.payload.id
        ),
        loading: false,
        // Patch current-page display immediately; invalidate cache so other pages refetch fresh
        page_cache: {},
      }

    case DELETE_USER_NOTIFICATIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:
      return state
  }
}

export default NotificationsTerminal
